export class ScheduleGroupEntity {
    scheduleGroupId: string
    name: string
    companyId: string
    createdAt: Date
    updatedAt: Date
    status: number
}
